import { getRequest, postRequest } from "../../apiClient";
import { PaymentsEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const StripeWebhookService = async () => {
    var _url = PaymentsEndpoint.STRIPE_WEBHOOK_URL;
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const StripeSetupIntentService = async () => {
    var res = await postRequest(PaymentsEndpoint.STRIPE_SETUP_INTENT_URL);

    return res;
};

export const StripeMakePaymentService = async (param: any) => {
    var res = await postRequest(PaymentsEndpoint.STRIPE_MAKE_PAYMENT_URL, param);

    return res;
};
//#endregion